import { Dispatch } from 'react';
import { InsuranceJourneyImportantNoticeInformationDetailsType } from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const ImportantNoticeInformationPageEventHandlers = (
  importantNoticeInformationDetails: InsuranceJourneyImportantNoticeInformationDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeReadAndUnderstoodImportantInformationNotice: (value: boolean) => {
      dispatch({
        type: 'set-important-notice-information-details',
        importantNoticeInformationDetails: {
          ...importantNoticeInformationDetails,
          readAndUnderstoodImportantInformationNotice: value
        }
      });
    }
  };
};
